// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file temporal/ontology/project_sync.proto (package gx.temporal.ontology, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../services/database/models/public_pb.js";
import { file_services_ontology_resources_pipeline_event } from "../../services/ontology/resources/pipeline_event_pb.js";
import { file_services_project_resources_project_configuration_project_configuration } from "../../services/project/resources/project_configuration/project_configuration_pb.js";
import { file_temporal_ontology_project_discovery } from "./project_discovery_pb.js";

/**
 * Describes the file temporal/ontology/project_sync.proto.
 */
export const file_temporal_ontology_project_sync = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public, file_services_ontology_resources_pipeline_event, file_services_project_resources_project_configuration_project_configuration, file_temporal_ontology_project_discovery]);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectSyncWorkflowInput.
 * Use `create(OntologyProjectSyncWorkflowInputSchema)` to create a new message.
 */
export const OntologyProjectSyncWorkflowInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 0);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectSyncWorkflowOutput.
 * Use `create(OntologyProjectSyncWorkflowOutputSchema)` to create a new message.
 */
export const OntologyProjectSyncWorkflowOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 1);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectSyncQueueWorkflowInput.
 * Use `create(OntologyProjectSyncQueueWorkflowInputSchema)` to create a new message.
 */
export const OntologyProjectSyncQueueWorkflowInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 2);

/**
 * Describes the message gx.temporal.ontology.OntologyProjectSyncQueueWorkflowOutput.
 * Use `create(OntologyProjectSyncQueueWorkflowOutputSchema)` to create a new message.
 */
export const OntologyProjectSyncQueueWorkflowOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 3);

/**
 * Describes the message gx.temporal.ontology.EnqueueOntologyProjectSyncWorkflowInput.
 * Use `create(EnqueueOntologyProjectSyncWorkflowInputSchema)` to create a new message.
 */
export const EnqueueOntologyProjectSyncWorkflowInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 4);

/**
 * Describes the message gx.temporal.ontology.EnqueueOntologyProjectSyncWorkflowOutput.
 * Use `create(EnqueueOntologyProjectSyncWorkflowOutputSchema)` to create a new message.
 */
export const EnqueueOntologyProjectSyncWorkflowOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 5);

/**
 * Describes the message gx.temporal.ontology.GatherSourceArtifactsActivityInput.
 * Use `create(GatherSourceArtifactsActivityInputSchema)` to create a new message.
 */
export const GatherSourceArtifactsActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 6);

/**
 * Describes the message gx.temporal.ontology.GatherSourceArtifactsActivityOutput.
 * Use `create(GatherSourceArtifactsActivityOutputSchema)` to create a new message.
 */
export const GatherSourceArtifactsActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 7);

/**
 * Describes the message gx.temporal.ontology.CheckSourcesReadyActivityInput.
 * Use `create(CheckSourcesReadyActivityInputSchema)` to create a new message.
 */
export const CheckSourcesReadyActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 8);

/**
 * Describes the message gx.temporal.ontology.CheckSourcesReadyActivityOutput.
 * Use `create(CheckSourcesReadyActivityOutputSchema)` to create a new message.
 */
export const CheckSourcesReadyActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 9);

/**
 * Describes the message gx.temporal.ontology.EmitProjectSyncStepStatusActivityInput.
 * Use `create(EmitProjectSyncStepStatusActivityInputSchema)` to create a new message.
 */
export const EmitProjectSyncStepStatusActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 10);

/**
 * Describes the message gx.temporal.ontology.UpdateProjectSyncStatusActivityInput.
 * Use `create(UpdateProjectSyncStatusActivityInputSchema)` to create a new message.
 */
export const UpdateProjectSyncStatusActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 11);

/**
 * Describes the message gx.temporal.ontology.CreateProjectVersionActivityInput.
 * Use `create(CreateProjectVersionActivityInputSchema)` to create a new message.
 */
export const CreateProjectVersionActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 12);

/**
 * Describes the message gx.temporal.ontology.CreateProjectVersionActivityOutput.
 * Use `create(CreateProjectVersionActivityOutputSchema)` to create a new message.
 */
export const CreateProjectVersionActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 13);

/**
 * Describes the message gx.temporal.ontology.CreateProjectSyncNotificationActivityInput.
 * Use `create(CreateProjectSyncNotificationActivityInputSchema)` to create a new message.
 */
export const CreateProjectSyncNotificationActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 14);

/**
 * Describes the message gx.temporal.ontology.CreateProjectSyncNotificationActivityOutput.
 * Use `create(CreateProjectSyncNotificationActivityOutputSchema)` to create a new message.
 */
export const CreateProjectSyncNotificationActivityOutputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 15);

/**
 * Describes the message gx.temporal.ontology.EnqueueProjectSyncActivityInput.
 * Use `create(EnqueueProjectSyncActivityInputSchema)` to create a new message.
 */
export const EnqueueProjectSyncActivityInputSchema = /*@__PURE__*/
  messageDesc(file_temporal_ontology_project_sync, 16);

